// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"06e6435d","151":"2ac52bc5","180":"d601449e"}[chunkId] + ".chunk.css";
};